import { render, staticRenderFns } from "./StaticData.vue?vue&type=template&id=1c2f47c7&scoped=true"
import script from "./StaticData.vue?vue&type=script&lang=js"
export * from "./StaticData.vue?vue&type=script&lang=js"
import style0 from "./StaticData.vue?vue&type=style&index=0&id=1c2f47c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f47c7",
  null
  
)

export default component.exports